function initialSelect() {
  // console.log("onload..");
  // console.log(document.getElementById("selectMake").options);
  let box = document.getElementsByClassName("select-box");
  let pid = box[0].dataset.pid ? box[0].dataset.pid : "";
  
  let colJsonEl = document.getElementsByClassName("colJson");
  let top = [];
  let data = {};

  for (let i = 0; i < colJsonEl.length; i++) {
      let isParent = false;
    if(pid) {
      isParent = colJsonEl[i].dataset.parent.indexOf(pid) > 0;
    }else {
      isParent = colJsonEl[i].dataset.parent == pid
    }
    
    if (isParent) {
      top.push({
        id: colJsonEl[i].dataset.id,
        title: colJsonEl[i].dataset.title,
        url: colJsonEl[i].dataset.url,
      });
    } else {
      let _parentInfo = colJsonEl[i].dataset.parent.split("/");
      if (data[_parentInfo[_parentInfo.length - 1]] == undefined)
        data[_parentInfo[_parentInfo.length - 1]] = [];
      data[_parentInfo[_parentInfo.length - 1]].push({
        id: colJsonEl[i].dataset.id,
        title: colJsonEl[i].dataset.title,
        url: colJsonEl[i].dataset.url,
      });
    }
  }

  if( pid ) {
    let tophtml = '<option value="">Model</option>';
      for (let j = 0; j < top.length; j++) {
        tophtml +=
          '<option value="' +
          top[j].id +
          '" data-url="' +
          top[j].url +
          '">' +
          top[j].title +
          "</option>";
      }
    if(document.getElementById("selectModel"))
        document.getElementById("selectModel").innerHTML = tophtml;
  }else {
     let tophtml = '<option value="">Make</option>';
      for (let j = 0; j < top.length; j++) {
        tophtml +=
          '<option value="' +
          top[j].id +
          '" data-url="' +
          top[j].url +
          '">' +
          top[j].title +
          "</option>";
      }
      // document.getElementById("selectMake").innerHTML = "";
      if(document.getElementById("selectMake"))
        document.getElementById("selectMake").innerHTML = tophtml;
  }
 

  // console.log(top);
  // console.log(tophtml);

  let selectArr = [
    "selectMake",
    "selectModel",
    "selectClassis",
    "selectEngine",
  ];
  let selectMap = {
    selectMake: 0,
    selectModel: 1,
    selectClassis: 2,
    selectEngine: 3,
  };
  let selectDefVal = {
    selectMake: "Make",
    selectModel: "Model",
    selectClassis: "Classis",
    selectEngine: "Engine",
  };

  function resetSelect(element) {
    let start = selectMap[element];
    // console.log("resetSelect", element, start);
    for (start += 1; start < 4; start++) {
      document.getElementById(selectArr[start]).innerHTML =
        '<option value="">' + selectDefVal[selectArr[start]] + "</option>";
    }
  }

  function fillNextSelect(element, optionArr) {
    // console.log("fillNextSelect", optionArr);
    let index = selectMap[element] + 1;
    let next = selectArr[index];
    let html = '<option value="">' + selectDefVal[next] + "</option>";
    if (optionArr == undefined || optionArr.length <= 0) {
      //html += '<option value="" disabled>Not More</option>';
    } else {
      for (let i = 0; i < optionArr.length; i++) {
        html +=
          '<option value="' +
          optionArr[i].id +
          '" data-url="' +
          optionArr[i].url +
          '">' +
          optionArr[i].title +
          "</option>";
      }
    }
    // console.log(next);
    // console.log(html);
    document.getElementById(next).innerHTML = html;
    if (index <= 3) {
      resetSelect(selectArr[index]);
    }
  }

  if(document.getElementById("selectMake")) {
    document.getElementById("selectMake").addEventListener("change", function () {
    if (this.value == "") {
      resetSelect("selectMake");
    } else {
      fillNextSelect("selectMake", data[this.value]);
    }
  });
  }
  

  document
    .getElementById("selectModel")
    .addEventListener("change", function () {
      if (this.value == "") {
        resetSelect("selectModel");
      } else {
        fillNextSelect("selectModel", data[this.value]);
      }
    });

  document
    .getElementById("selectClassis")
    .addEventListener("change", function () {
      if (this.value == "") {
        resetSelect("selectClassis");
      } else {
        fillNextSelect("selectClassis", data[this.value]);
      }
    });

  document
    .getElementById("selectEngine")
    .addEventListener("change", function () {
      // console.log(this.options[this.selectedIndex]);
      // console.log(this.options[this.selectedIndex].dataset.url);
      if (this.value == "") {
        return true;
      } else {
        window.location.href =
          window.location.origin + this.options[this.selectedIndex].dataset.url;
      }
    });

  if(document.getElementById("selectMake")){
    document.getElementById("selectMake").options[0].selected = true;
  }
    
}

initialSelect();
